<loading-bar></loading-bar>
<toast-message />
<router-outlet />